var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeStepsBackdrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1494,
    height: 665,
    viewBox: "0 0 1494 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_617_319",
    x: -157,
    y: -200,
    width: 1788,
    height: 1027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_617_319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_617_319",
    x1: 697.5,
    y1: -0.00000139367,
    x2: 697.5,
    y2: 687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFFEF6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_617_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397 570H878V597H1107V570H1389V606H1139V627H857V605H653V615H371V584H270V618H43V549H187V527H397V570ZM1164 108H1431V159H1149V122H882V85H1164V108ZM904 59H641V84H359V35H622V21H904V59ZM332 64H50V0H332V64Z",
    fill: "url(#paint0_linear_617_319)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 -80,8;                 30,-5;                 60,12;                 -90,-8;                 -20,6;                 70,-10;                 40,15;                 -60,3;                 0,0",
    dur: "12s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397 570H878V597H1107V570H1389V606H1139V627H857V605H653V615H371V584H270V618H43V549H187V527H397V570ZM1164 108H1431V159H1149V122H882V85H1164V108ZM904 59H641V84H359V35H622V21H904V59ZM332 64H50V0H332V64Z",
    fill: "url(#paint0_linear_617_319)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 90,-10;                 -40,8;                 -70,-6;                 110,15;                 30,-8;                 -80,5;                 -50,-12;                 60,10;                 0,0",
    dur: "13s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397 570H878V597H1107V570H1389V606H1139V627H857V605H653V615H371V584H270V618H43V549H187V527H397V570ZM1164 108H1431V159H1149V122H882V85H1164V108ZM904 59H641V84H359V35H622V21H904V59ZM332 64H50V0H332V64Z",
    fill: "url(#paint0_linear_617_319)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "                 0,0;                 -60,12;                 80,-6;                 -30,-10;                 50,5;                 -90,18;                 40,-12;                 70,8;                 -50,-5;                 0,0",
    dur: "14s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStepsBackdrop);
export default __webpack_public_path__ + "static/media/three_steps_backdrop.5da8ace2c1d9a9458e0fc8cbdf862d65.svg";
export { ForwardRef as ReactComponent };